// packages/shared-components/src/components/LoadingDotsMask/LoadingDotsMask.tsx

import React from "react";
import { LoadingDotsMaskProps } from "./types";
import styles from "./LoadingDotsMask.module.css";

/**
 * LoadingDotsMask - 四点弹跳加载遮罩组件
 *
 * 四个圆点依次跳起，颜色使用主题色 --primary-color
 *
 * 示例：
 * `<LoadingDotsMask visible={isLoading} text="加载中..." />`
 */
export const LoadingDotsMask: React.FC<LoadingDotsMaskProps> = ({
  visible,
  className = "",
}) => {
  if (!visible) return null;

  return (
    <div className={`${styles.overlay} ${className}`}>
      <div className={styles.dots}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>
    </div>
  );
};
